import { render, staticRenderFns } from "./vendor-permissions.vue?vue&type=template&id=3e9132e5&lang=pug"
import script from "./vendor-permissions.vue?vue&type=script&lang=js"
export * from "./vendor-permissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports